<template>
  <artmisads-modal
    v-model:open="visible"
    :title="$t('seller.brandsPage.setUpAssociatePartnershipTitle')"
    :width="1200"
    :maskClosable="false"
    @cancel="handleCancel"
    :footer="null"
  >
    <div class="publisher-modal-content">
      <div :style="currentStep===1?'margin-bottom: 24px;':'margin-bottom: 40px;'">
        <div class="title">
        {{ $t('seller.brandsPage.breadcrumbBrand') }}
      </div>
      <div class="tag-item">
         <LogoImage :maxWidth="'95%'" :logoUrl="logoImageUrl" :brandName="amazonBrandName" :width="20"
            :height="20" :lineHeight="6" :fontSize="5" :borderRadius="4" />
         <span>{{ brandName }}</span>
       </div>
     
      </div>
      <div v-if="currentStep===1" class="title" style="padding-bottom: 24px; padding-top: 0;">{{ $t('seller.brandsPage.selectPublisherStepTitle') }}</div>
     <artmisads-table 
     v-if="currentStep===1"
     :columns="columns" 
     :data-source="data" 
     :loading="loading"
     :row-key="record=>record.id"
     :scroll="{y:400,x:800}"
     :row-selection="{
      selectedRowKeys: selectedRowKeys,
      onChange: onSelectChange
    }"
    :change="onPageChange"
     :pagination="{
        pageSize: params.pageSize,
        current: params.page,
        total: params.total,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200']
     }">
       <template #bodyCell="{ column, text, record }"> 
        <template v-if="column.dataIndex === 'publisher'">
          <a-flex gap="12" align="center">
            <LogoImage  :logoUrl="record?.publicImage" :brandName="record?.creatorName" :width="56"
             :height="56" :fontSize="12" />
             <span>
            {{ record?.creatorName }}
              </span>
          </a-flex>
         
        </template>
        <template v-if="column.dataIndex === 'promotionCountries'">
          <div class="promotion-countries">
            <AutoTooltip
            :content="record?.promotionCountries ? getComputedData(record?.promotionCountries) : '--'"
            :width="120" />
           
          </div>
        </template>
        <template v-if="column.dataIndex === 'promotionMethods'">
          <AutoTooltip
            :content="record?.promotionMethods ? getComputedData(record?.promotionMethods) : '--'"
            :width="120" />
         
        </template>
        <template v-if="column.dataIndex === 'promotionProductCategories'">
          <AutoTooltip
            :content="record?.promotionProductCategories ? getComputedData(record?.promotionProductCategories) : '--'"
            :width="120" />
         
        </template>
        <template v-if="column.dataIndex === 'bio'">
          <AutoTooltip
            :content="record?.publicBio ? record?.publicBio : '--'"
           
            :contentWidth="500"
            :width="120" />
         
        </template>
        <template v-if="column.dataIndex === 'partnershipStatus'">
        
          {{
            record?.associateBrandCount
              ? $t('seller.brandsPage.partnershipPartnered')
              : $t('seller.brandsPage.partnershipNotPartnered')
          }}
        </template>
       </template>
      </artmisads-table>
      <setUpPartnershipSecond @refresh="refresh" ref="setUpPartnershipSecondRef" v-if="currentStep===2" />
    </div>
    <div class="footer-btn" v-if="currentStep===1">
      <artmisads-button type="primary" :disabled="!allSelectedRowKeys.size" :isSquare="true" @click="goNext">
        {{ $t('seller.brandsPage.next') }}
      </artmisads-button>
    </div>
  </artmisads-modal>
</template>

<script setup>
import i18n from '~/i18n'

import { ref, computed, nextTick  } from 'vue';
import { useI18n } from 'vue-i18n';
import { publishersApi } from '@/server'
import { message } from 'ant-design-vue';
import LogoImage from '@/components/LogoImage.vue';
import AutoTooltip from '@/components/AutoTooltip.vue';
import setUpPartnershipSecond from './setUpPartnershipSecond.vue';


// 内部状态管理
const currentStep = ref(1);
const visible = ref(false);
const brandId = ref('');
const amazonBrandName = ref('')
const logoImageUrl = ref('')
const publisherTableRef = ref(null);
const setUpPartnershipSecondRef = ref(null);
const params=ref({
  page:1,
  pageSize:10,
  total:0
})
const brandName = ref('')
const { t, locale } = useI18n()
const columns = computed(() => {
  locale.value
  return [
    {
      title: t('seller.brandsPage.colPublisher'),
      dataIndex: 'publisher',
      key: 'publisher',
    },
    {
      title: t('seller.brandsPage.colPromotionCountries'),
      dataIndex: 'promotionCountries',
      key: 'promotionCountries',
      width: 180,
    },
    {
      title: t('seller.brandsPage.colPromotionMethod'),
      dataIndex: 'promotionMethods',
      key: 'promotionMethods',
      width: 180,
    },
    {
      title: t('seller.brandsPage.colProductCategories'),
      dataIndex: 'promotionProductCategories',
      key: 'promotionProductCategories',
      width: 180,
    },
    {
      title: t('seller.brandsPage.colBio'),
      dataIndex: 'bio',
      key: 'bio',
      width: 180,
    },
    {
      title: t('seller.brandsPage.colPartnershipStatus'),
      dataIndex: 'partnershipStatus',
      key: 'partnershipStatus',
    },
  ]
})
const data=ref([])
const selectedRowKeys = ref([])
const selectedRowKeysAll = ref([])

// 新增：跨页选择状态管理
const allSelectedRowKeys = ref(new Set()) // 存储所有页面的选择状态
const allSelectedRows = ref(new Map()) // 存储所有页面的选择行数据

const onSelectChange = (newSelectedRowKeys, selectedRows) => {
  // 更新当前页的选择状态
  selectedRowKeys.value = newSelectedRowKeys
  
  // 更新全局选择状态
  const currentPageIds = data.value.map(item => item.id)
  
  // 移除当前页之前的选择状态
  currentPageIds.forEach(id => {
    allSelectedRowKeys.value.delete(id)
    allSelectedRows.value.delete(id)
  })
  
  // 添加当前页新的选择状态
  newSelectedRowKeys.forEach(key => {
    allSelectedRowKeys.value.add(key)
    const row = selectedRows.find(item => item.id === key)
    if (row) {
      allSelectedRows.value.set(key, row)
    }
  })
  
  // 更新全局选择数组
  selectedRowKeysAll.value = Array.from(allSelectedRows.value.values())
}

// 设置当前页的勾选状态
const setCurrentPageSelection = () => {
  // 根据全局选择状态设置当前页的勾选状态
  const currentPageSelectedKeys = data.value
    .filter(item => allSelectedRowKeys.value.has(item.id))
    .map(item => item.id)
  
  selectedRowKeys.value = currentPageSelectedKeys
}
const loading=ref(false)
const onPageChange=({current,pageSize})=>{
  params.value.page=current
  params.value.pageSize=pageSize
  // 翻页时不清空选择状态，保留之前的选择
  getList()
}
const getComputedData = (item) => {

if (Array.isArray(item)) {
  if (item.length > 0) {
    return item.map(item => item.name).join(',')
  }
  else {
    return '--'
  }
}
else {
  return '--'
}
}
const getList=async()=>{
  loading.value = true
 
  try {
    const res = await publishersApi.getPublishersByBrandId({
      page: params.value.page,
      size: params.value.pageSize,
      brandId:brandId.value
    })
    if (res.success) {
      data.value = res.data?.data?.map(item => ({
        ...item.publisherVO,
        associateBrandCount: item.associateBrandCount
      }))
      data.value?.forEach(item => {
        if (item?.links) {
          item.links = item?.links?.filter(link => {
            return link.url
          })
        }
      })
      params.value.total = res.data.total
      
      // 数据加载完成后恢复勾选状态
      setTimeout(() => {
        setCurrentPageSelection()
      }, 200)
    } else {
      message.error(res.error)
    }
  } catch (error) {
    message.error(i18n.global.t('seller.msg.getDataFailed'))
  } finally {
    loading.value = false
  }
}
const goNext = async () => {
  currentStep.value = 2
  selectedRowKeysAll.value.map(item=>{
    item.brandId=brandId.value
  })


  await nextTick()
  setUpPartnershipSecondRef.value?.showModal(selectedRowKeysAll.value)
}
// 清空所有选择状态
const clearAllSelection = () => {
  selectedRowKeys.value = []
  selectedRowKeysAll.value = []
  allSelectedRowKeys.value.clear()
  allSelectedRows.value.clear()
  params.value.page=1
}

// 打开弹窗的方法
const open = (id, name,amazonBrandNameStr,imageUrl) => {
  brandId.value = id
  brandName.value = name
  amazonBrandName.value = amazonBrandNameStr
  logoImageUrl.value = imageUrl
  visible.value = true;
  currentStep.value = 1
  // 清空所有选择状态
  clearAllSelection()
  getList()

};

// 关闭弹窗
const handleCancel = () => {
  visible.value = false;
};

const refresh = () => {
  currentStep.value = 1
  // 清空所有选择状态
  clearAllSelection()
  getList()
}

// 暴露方法给父组件
defineExpose({
  open
});
</script>

<style lang="less" scoped>
  .tag-item {
      display: inline-flex;
    padding: 3px 4px;

    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #F1F0F5;
      // margin: 4px 8px 4px 0;
      // padding: 4px 8px;
   
      font-size: 13px;

 line-height: 15px;
 letter-spacing: 0.3px;

 span{
      font-family: "Sora";
 opacity: 0.7;
 color: #0f0629;
     }
    }
  .title {
    padding: 8px 0;
    // border-top: 1px solid #e8e8e8;
    color: #0f0629;
    font-family: "Sora";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;

    letter-spacing: 0.4px;
    opacity: 0.9;
  }
.footer-btn{
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
</style>